import { useRef } from 'react'
import { toEditorHtml } from './richText'

/** The value to hand a rich-text editor, and the change handler to give it.
 *  A value from elsewhere — a copied request, a chat tool, the server — goes
 *  through `toEditorHtml`; the editor's own output goes back to it untouched.
 *  Converting that too would turn a first keystroke "a" into "<p>a</p>", and
 *  the editor rewrites itself (losing the caret) whenever its value changes
 *  under it (#42368). */
export function useEditorHtml(value: string, onChange: (html: string) => void) {
  const emitted = useRef<string | null>(null)
  const html = value === emitted.current ? value : toEditorHtml(value)

  function handleChange(next: string) {
    emitted.current = next
    onChange(next)
  }

  return [html, handleChange] as const
}
